export const courseSchema = {
    // Course
    studentType: {
      label: "Student Type",
      type: "select",
      name: "category",
      options: [
        "Senior Secondary School",
        "Junior Secondary School",
        "Basic School",
        "Special Needs",
        "Vocational",
      ],
    },
    // courseType: {
    //   label: 'Course Type',
    //   type: 'select',
    //   name: 'courseType',
    //   options: [
  
    //   ],
    // },
    courseType: {
      label: "Course Type",
      type: "select",
      options: ["Pre-Recorded", "Live"],
    },
    category: {
      label: "Category",
      type: "select",
      name: "subCategory",
      options: [
        "Humanities",
        "Arts & Humanities",
        "Sciences",
        "Commercial",
        "General",
      ],
    },
    subject: {
      label: "Subject",
      type: "select",
      name: "subject",
      options: [
        "Further Mathematics",
        "Government",
        "Integrated Science",
        "Mathematics",
        "French",
        "Accounting",
        "Chemistry",
        "Christian Religious Studies",
      ],
    },
    plan: {
      label: "Plan",
      type: "select",
      name: "plan",
      options: ["Free", "Premium", "Paid"],
    },
    class: {
      label: "Class",
      type: "select",
      options: ["SS 1", "SS 2", "SS 3"],
      name: "class",
    },
    courseName: {
      label: "Course Name",
      type: "text",
      name: "title",
    },
    courseDuration: {
      label: "Course Duration",
      type: "text",
      name: "duration",
    },
    tutorName: {
      label: "Tutor's Name",
      type: "text",
      name: "tutor",
    },
    price: {
      label: "Price NGN",
      type: "text",
      name: "price",
    },
    courseCoverPhoto: {
      label: "Course Cover Photo",
      type: "file",
      name: "thumbnail",
    },
    courseFile: {
      label: "Course File(s)",
      type: "file",
    },
    courseDescription: {
      label: "Course Description",
      type: "textarea",
      name: "description",
    },
  
    // Event
    eventName: {
      label: "Event Name",
      type: "text",
    },
    eventDate: {
      label: "Event Date",
      type: "date",
    },
    eventStartTime: {
      label: "Event Start Time",
      type: "time",
    },
    eventEndTime: {
      label: "Event End Time",
      type: "time",
    },
    capacity: {
      label: "Capacity",
      type: "select",
      options: ["Physical"],
    },
    location: {
      label: "Location",
      type: "text",
    },
    conveyer: {
      label: "conveyer",
      type: "text",
    },
    eventType: {
      label: "Event Type",
      type: "select",
      options: ["All Students"],
    },
    eventPrice: {
      label: "Price NGN",
      type: "text",
    },
    eventCoverPhoto: {
      label: "Cover Photo",
      type: "file",
    },
    eventDescription: {
      label: "Event Description",
      type: "textarea",
    },
  
    // Quiz
    quizCategory: {
      label: "Category",
      type: "select",
      options: [
        "Mobile Capacity",
        "Special / Audio Visual Capacity",
        "Interactive Session",
        "Professional",
      ],
    },
    quizSubCategory: {
      label: "Sub Category",
      type: "select",
      options: [
        "District 1",
        "District 2",
        "District 3",
        "District 4",
        "District 5",
        "All",
      ],
    },
    quizCourseName: {
      label: "Course Name",
      type: "text",
    },
    quizCourseDuration: {
      label: "Course Duration",
      type: "time",
    },
    trainingType: {
      label: "Training Type",
      type: "select",
      options: ["Pre-Recorded", "Live"],
    },
    dateTime: {
      label: "Date and Time",
      type: "datetime-local",
    },
    InstructorName: {
      label: `Instructor’s Name`,
      type: "text",
    },
    quizPrice: {
      label: "Price NGN",
      type: "text",
    },
    quizCoverPhoto: {
      label: "Course Cover Photo",
      type: "file",
    },
    quizCourseFile: {
      label: "Course File",
      type: "file",
    },
    quizCourseDescription: {
      label: "Course   Description",
      type: "textarea",
    },
  };
  
  export const userSchema = {
    name: {
      label: "Name",
      type: "text",
    },
    email: {
      label: "Email",
      type: "email",
    },
    mobileNumber: {
      label: "Mobile Number",
      type: "text",
    },
    sector: {
      label: "Sector",
      type: "select",
      options: ["Public School", "Private School", "Quests"],
    },
    category: {
      label: "Category",
      type: "select",
      options: ["Senior School", "Junior School", "Basic School"],
    },
    school: {
      label: "School",
      type: "text",
    },
    LocalGvt: {
      label: "LGA",
      type: "select",
      options: ["Allen", "Ikeja", "Opebi"],
    },
    class: {
      label: "Class",
      type: "select",
      options: ["SS1", "SS2", "SS3"],
    },
    ageRange: {
      label: "Age Range",
      type: "select",
      options: ["14-19", "15-20", "21-30"],
    },
    profile: {
      label: "Profile Picture",
      type: "file",
    },
  };
  
  export const roleSchema = {
    firstName: {
      label: "First Name",
      type: "text",
      name: "firstName",
    },
    lastName: {
      label: "Last Name",
      type: "text",
      name: "lastName",
    },
    email: {
      label: "Email",
      type: "email",
      name: "email",
    },
    role: {
      label: "Role",
      type: "select",
      name: "role",
      options: [
        "teacher-manager",
        "student-manager",
        "counsellor-manager",
        "specialNeed-manager",
      ],
      placeHolder: "Role",
    },
  };
  export const productSchema = {
    productName: {
      label: "Product Name",
      type: "text",
    },
    category: {
      label: "category",
      type: "select",
      options: ["Student", "Teacher", "Game"],
    },
    price: {
      label: "Price NGN",
      type: "text",
    },
    discount: {
      label: "Discount (NGN)",
      type: "text",
    },
    numberInStock: {
      label: "Number in Stock",
      type: "text",
    },
    description: {
      label: "Description",
      name: "description",
    },
  };
  
  
  export const profileSchema = {
    firstName: {
      label: "First Name",
      type: "text",
    },
    lastName: {
      label: "Last Name",
      type: "text",
    },
    emailAddress: {
      label: "Email Address",
      type: "text",
    },
    phoneNumber: {
      label: "Phone Number",
      type: "text",
    },
  
   
  };
  